import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { APP_CONFIG } from '../../app-config';


/**
 * Component that indicates the loading state of another component or page.
 */
@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LoaderComponent {

	readonly LOADER_URL: string = `${inject(APP_CONFIG).cdnUrl}/style/images/loading.gif`;

}
